import useTrackedMutation from 'hooks/useTrackedMutation';
import {useLocale} from 'state/locale';
import Api from 'types/api';
import {request} from 'utils/request-axios';
import {TeamMemberGroupsBackendData} from './types';

type PossibleResponses =
    | Api.Response.SuccessAxios<
          'refreshData',
          TeamMemberGroupsBackendData['data']
      >
    | Api.Response.RedirectAxios<'upgrade_groups'>;

const useToggleTeamMemberGroup = (teamMemberMid: string) => {
    const locale = useLocale();

    return useTrackedMutation<
        PossibleResponses,
        Error,
        {
            groupMid: string;
        }
    >(({groupMid}) =>
        request({
            formData: {team: groupMid},
            locale,
            method: 'POST',
            url: `/ui/team/members/${teamMemberMid}/groups/${groupMid}/toggle/`,
        }),
    );
};

export default useToggleTeamMemberGroup;
